<template>
    <div class="home">
        <div class="home-head">
            <div>
                <el-col :span="9">
                    <img :src="coverUrl" @click="drawerMenuList = true" />
                </el-col>
                <el-col :span="15">
                    <span>剑桥少儿英语1对1</span>
                </el-col>
            </div>

        </div>
        <div class="home-list">
            <div style="height: 70px;"></div>
            <div class="home-list-title">
                <span>图书资源</span>
            </div>
            <div>
                <el-table :data="menuList" v-loading="this.loading" :height="tableHeight">
                    <el-table-column prop="productIndex" label="目录" width="20" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.row.productIndex }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="words" label="单词">
                    </el-table-column>
                    <el-table-column style="text-align: center;" label="听力" align="right">
                        <template slot-scope="scope">
                            <i class="el-icon-arrow-right" @click="goto(scope.row)"></i>
                        </template>
                    </el-table-column>
                </el-table>

            </div>
            <div>
                <el-drawer title="图书简介" :visible.sync="drawerMenuList" direction="btt" size="40">
                    <el-form ref="form" label-position="top" label-width="80px">
                        <el-form-item label="书名">
                            <span>剑桥少儿英语1对1</span>
                        </el-form-item>
                        <el-form-item label="作者">
                            <span>北京新知堂科技发展有限公司</span>
                        </el-form-item>
                        <el-form-item label="出版社">
                            <span>西安交通大学出版社</span>
                        </el-form-item>
                        <el-form-item label="简介">
                            <span>扫码听</span>
                        </el-form-item>
                    </el-form>
                </el-drawer>
            </div>
        </div>

    </div>
</template>
<script>
import api from '@/utils/api'
export default {
    data () {
        return {
            drawerMenuList: false,
            loading: false,
            tableHeight: 0,
            menuList: [],
            level: 1,
            coverUrl: ''
        }
    },
    created () {
        this.tableHeight = (window.innerHeight - 235)
        this.level = this.$route.query.level
        this.coverUrl = '/static/S/level0' + this.level + '/cover/level' + this.level + '.png'
        this.initData()
    },
    methods: {
        initData: function () {
            this.loading = true
            this.$axios.get(api.getQrListeningByLevel(this.level))
                .then(res => {
                    this.menuList = res.data.result
                    this.loading = false
                })
        },
        goto: function (row) {
            console.log(row)
            this.$router.push('/qrstudy?code=' + row.prodctCode)
        }
    }
}
</script>
<style scoped lang="less">
.home {
    background-color: #606266;
    height: 844px;
    overflow: hidden;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    padding: 5px;
}

.home-head {
    height: 120px;
    font-size: 20px;
    font-weight: 700;
    color: #e7e4e4;
}

.home-head img {
    width: 100px;
    padding: 15px 0 0 15px;
    -webkit-tap-highlight-color: transparent;
}

.home-head span {
    line-height: 120px;
}

.home-list {
    border-radius: 20px 20px 0 0;
    background-color: #fff;
    height: 744px;
}

.home-list-title {
    height: 40px;
}

.home-list-title span {
    font-size: 22px;
    font-weight: 700;
    padding-left: 10px;
}

/deep/ .el-form--label-top .el-form-item__label {
    padding: 0;
}

/deep/.el-form-item {
    margin-bottom: 0px;
    padding-left: 10px;
}

/deep/.el-form-item__content {
    font-weight: 700;
    color: #75777a;
    font-size: 16px;
}

/deep/.el-drawer__header>:first-child {
    -webkit-box-flex: 0;
    text-align: center;
    font-size: 20px;
    -webkit-tap-highlight-color: transparent;
    border: 0;
}

/deep/.el-icon-headset,
.el-icon-arrow-right {
    color: #E6A23C;
    font-size: 16px;
    padding-right: 10px;
    font-weight: 700;
}

/deep/:focus-visible {
    outline: -webkit-focus-ring-color auto 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/qrlistening/home.vue